// Gallery Data - Person-centric organization
import {
    amitShahHM,
    bhadresdasSwami,
    bhadresdasSwami1,
    bhadresdasSwami2,
    bhartiyaBasantKumar,
    bhartiyaBasantKumar1,
    bhartiyaBasantKumar2,
    bhartiyaBasantKumar3,
    bhartiyaBasantKumar4,
    bhupendrasinhChudasama,
    bhupendrasinhChudasama1,
    bhupendrasinhChudasama2,
    bhupendrasinhChudasama3,
    bhupendrasinhChudasama4,
    bhushanGavai,
    bhushanGavai1,
    bhushanGavai2,
    bhushanGavai3,
    convocation43rdGajendraSinghShekhawat,
    convocation43rdGoverner,
    convocation43rdGovernor2,
    council,
    danikjagran,
    danikjagran3,
    danikjagran6,
    danikjagran7,
    darshanaSingh,
    darshanaSingh1,
    darshanaSingh2,
    darshanaSingh3,
    deputyCM,
    deputyCM2,
    dineshChandraVHP1,
    dineshChandraVHP2,
    dineshChandraVHP3,
    drKrishanGopal,
    drKrishanGopal1,
    drKrishanGopal2,
    drKrishanGopal3,
    durgaShankarMishra,
    durgaShankarMishra1,
    durgaShankarMishra2,
    durgaShankarMishra3,
    event1,
    event10,
    event11,
    event12,
    event13,
    event14,
    event15,
    event16,
    event17,
    event18,
    event19,
    event2,
    event20,
    event21,
    event22,
    event23,
    event24,
    event25,
    event26,
    event27,
    event28,
    event29,
    event3,
    event30,
    event31,
    event32,
    event33,
    event34,
    event35,
    event36,
    event37,
    event38,
    event39,
    event4,
    event40,
    event41,
    event42,
    event43,
    event44,
    event45,
    event46,
    event47,
    event48,
    event49,
    event5,
    event50,
    event51,
    event52,
    event53,
    event54,
    event55,
    event56,
    event57,
    event58,
    event59,
    event6,
    event60,
    event61,
    event62,
    event63,
    event64,
    event65,
    event66,
    event67,
    event68,
    event69,
    event7,
    event70,
    event71,
    event72,
    event73,
    event74,
    event75,
    event76,
    event77,
    event78,
    event79,
    event8,
    event80,
    event9,
    formerEducationMinisterIndia,
    gajendraSinghShekhawat1,
    gajendraSinghShekhawat2,
    girirajSinghTextileMinister,
    girirajSinghTextileMinister1,
    girirajSinghTextileMinister2,
    girirajSinghTextileMinister3,
    governer,
    governor10,
    governor2,
    governor3,
    governor4,
    governor7,
    governor8,
    governor9,
    gyanPrakashSharmaJonpur,
    gyanPrakashSharmaJonpur1,
    gyanPrakashSharmaJonpur2,
    harivanshNarayanSingh,
    harivanshNarayanSingh1,
    harivanshNarayanSingh2,
    harivanshNarayanSingh3,
    higherEducationMinister,
    higherEducationMinister1,
    jagdeepDhankar1FormerVC,
    jagdeepDhankar2FormerVC,
    jagdeepDhankarFormerVC,
    jpNadda,
    jpNadda1,
    jpNadda10,
    jpNadda11,
    jpNadda2,
    jpNadda3,
    jpNadda4,
    jpNadda5,
    jpNadda6,
    jpNadda7,
    jpNadda8,
    jpNadda9,
    justiceSanjayKarol,
    kashiVishvnath,
    laxmaAcharyaGovernorAssam,
    laxmaAcharyaGovernorAssam1,
    laxmaAcharyaGovernorAssam2,
    laxmaAcharyaGovernorAssam3,
    library,
    mahendraNathPandey,
    mahendraNathPandey1,
    mahendraNathPandey2,
    meetWithGajendraSinghShekhawat,
    missouriStateTreasurer,
    missouriStateTreasurer1,
    mohanYadavCMMP,
    mpEducationMeeting,
    ncc1,
    ncc2,
    ncc3,
    ncc4,
    ncc5,
    ncc6,
    ncc7,
    pm,
    pm2,
    premKumarSpeakerBihar,
    premKumarSpeakerBihar1,
    premKumarSpeakerBihar2,
    premKumarSpeakerBihar3,
    premKumarSpeakerBihar4,
    president,
    president1,
    president2,
    rambhadracharya,
    rameshChanderKaushik,
    rameshChanderKaushik1,
    sanskritScholarshipCm,
    shriAshokKumarTiwariMayor,
    shriAshokKumarTiwariMayor1,
    shriAshokKumarTiwariMayor2,
    shriAshokKumarTiwariMayor3,
    shriNeelkanthTiwari,
    shriSunilAmbekar,
    shriSunilAmbekar1,
    shriSureshKumarKhanna,
    shriSureshKumarKhanna1,
    spiritual,
    sunilBansal,
    sunilBansal1,
    sunilBansal2,
    sureshSoniRSS,
    sureshSoniRSS1,
    sureshSoniRSS2,
    sureshSoniRSS3,
    sureshSoniRSS4,
    sureshSoniRSS5,
    tourisomMinister,
    tourisomMinister2,
    tourisomMinister3,
    tourisomMinister4,
    tourisomMinister5,
    tourisomMinister7,
    transportMinister,
    transportMinister2,
    transportMinister3,
    ujjan,
    universityEvent01,
    vicepresident,
    vicepresident2,
    vishwaBhushanMishra,
    vishwaBhushanMishra1,
    vishwaBhushanMishra2,
    vishwaBhushanMishra3,
    vishwaBhushanMishra4,
    vishwaBhushanMishra5,
    worldTourisomDay,
    yogiCMUP10,
    yogiCMUP11,
    yogiCMUP12,
    yogiCMUP2,
    yogiCMUP3,
    yogiCMUP5,
    yogiCMUP8,
    yogiCMUP9
} from '../assets/gallary';

export const galleryCategories = [
   
    {
        id: 'president',
        title: 'Hon. President of India',
        description: 'With Smt. Droupadi Murmu, President of India.',
        thumbnail: president,
        images: [
            {
                src: president,
                alt: 'Meeting with Hon. President of India',
                description: 'Official meeting with the President of India'
            },
            {
                src: president1,
                alt: 'With President of India',
                description: 'Interaction with the President of India'
            },
            {
                src: president2,
                alt: 'Presidential Event',
                description: 'Presidential ceremony and interaction'
            }
        ]
    },
    {
        id: 'vice-president',
        title: 'Hon. Vice President Shri C. P. Radhakrishnan',
        description: 'With Shri C. P. Radhakrishnan, Vice President of India.',
        thumbnail: vicepresident,
        images: [
            {
                src: vicepresident,
                alt: 'Meeting with Hon. Vice President C. P. Radhakrishnan',
                description: 'Official meeting with Vice President Shri C. P. Radhakrishnan'
            },
            {
                src: vicepresident2,
                alt: 'With Vice President C. P. Radhakrishnan',
                description: 'Interaction with Vice President Shri C. P. Radhakrishnan'
            }
        ]
    },
   
     {
        id: 'prime-minister',
        title: 'Hon. Prime Minister of India',
        description: 'With Shri Narendra Modi, Prime Minister of India.',
        thumbnail: pm,
        images: [
            {
                src: pm,
                alt: 'Meeting with Hon. Prime Minister',
                description: 'Official meeting with Prime Minister Shri Narendra Modi'
            },
          
            {
                src: pm2,
                alt: 'Prime Minister Event',
                description: 'Event with Prime Minister Shri Narendra Modi'
            }
        ]
    },
     {
        id: 'amit-shah',
        title: 'Shri Amit Shah',
        description: 'With Shri Amit Shah, Union Home Minister of India.',
        thumbnail: amitShahHM,
        images: [
            {
                src: amitShahHM,
                alt: 'Meeting with Hon. Home Minister Amit Shah',
                description: 'Official meeting with Union Home Minister Shri Amit Shah'
            }
        ]
    },
    {
        id: 'jp-nadda',
        title: 'Shri JP Nadda',
        description: 'With Shri J. P. Nadda, Union Minister, Government of India.',
        thumbnail: jpNadda4,
        images: [
            {
                src: jpNadda,
                alt: 'Meeting with Shri JP Nadda',
                description: 'Official meeting with Union Minister Shri JP Nadda'
            },
            {
                src: jpNadda1,
                alt: 'With JP Nadda',
                description: 'Interaction with Shri JP Nadda'
            },
            {
                src: jpNadda2,
                alt: 'JP Nadda Event',
                description: 'Event with Union Minister JP Nadda'
            },
            {
                src: jpNadda3,
                alt: 'With JP Nadda',
                description: 'Meeting with Shri JP Nadda'
            },
            {
                src: jpNadda4,
                alt: 'JP Nadda Program',
                description: 'Program with Union Minister JP Nadda'
            },
            {
                src: jpNadda5,
                alt: 'With JP Nadda',
                description: 'Interaction with Shri JP Nadda'
            },
            {
                src: jpNadda6,
                alt: 'JP Nadda Event',
                description: 'Event with Union Minister JP Nadda'
            },
            {
                src: jpNadda7,
                alt: 'With JP Nadda',
                description: 'Meeting with Union Minister JP Nadda'
            },
            {
                src: jpNadda8,
                alt: 'JP Nadda Program',
                description: 'Program with Union Minister JP Nadda'
            },
            {
                src: jpNadda9,
                alt: 'With JP Nadda',
                description: 'Meeting with Union Minister JP Nadda'
            },
             {
                src: jpNadda10,
                alt: 'With JP Nadda',
                description: 'Meeting with Union Minister JP Nadda'
            },
             {
                src: jpNadda11,
                alt: 'With JP Nadda',
                description: 'Meeting with Union Minister JP Nadda'
            }
        ]
    },
   
    {
        id: 'gajendra-singh',
        title: 'Shri Gajendra Singh Shekhawat',
        description: 'With Shri Gajendra Singh Shekhawat, Union Minister, Government of India.',
        thumbnail: gajendraSinghShekhawat2,
        images: [
            {
                src: convocation43rdGajendraSinghShekhawat,
                alt: '43rd Convocation with Gajendra Singh Shekhawat',
                description: '43rd Convocation ceremony with Union Minister Shri Gajendra Singh Shekhawat'
            },
            {
                src: meetWithGajendraSinghShekhawat,
                alt: 'Meeting with Gajendra Singh Shekhawat',
                description: 'Official meeting with Union Minister Shri Gajendra Singh Shekhawat'
            },
            {
                src: gajendraSinghShekhawat1,
                alt: 'With Gajendra Singh Shekhawat',
                description: 'Meeting with Union Minister Shri Gajendra Singh Shekhawat'
            },
            {
                src: gajendraSinghShekhawat2,
                alt: 'Gajendra Singh Shekhawat Event',
                description: 'Event with Union Minister Shri Gajendra Singh Shekhawat'
            }
        ]
    },
    {
        id: 'giriraj-singh',
        title: 'Shri Giriraj Singh',
        description: 'With Shri Giriraj Singh, Union Minister, Government of India.',
        thumbnail: girirajSinghTextileMinister,
        images: [
            {
                src: girirajSinghTextileMinister,
                alt: 'Meeting with Shri Giriraj Singh',
                description: 'Official meeting with Union Minister Shri Giriraj Singh'
            },
            {
                src: girirajSinghTextileMinister1,
                alt: 'With Shri Giriraj Singh',
                description: 'Interaction with Union Minister Shri Giriraj Singh'
            },
            {
                src: girirajSinghTextileMinister2,
                alt: 'Event with Shri Giriraj Singh',
                description: 'Event with Union Minister Shri Giriraj Singh'
            },
            {
                src: girirajSinghTextileMinister3,
                alt: 'With Shri Giriraj Singh',
                description: 'Meeting with Union Minister Shri Giriraj Singh'
            }
        ]
    },
      {
        id: 'dr-krishan-gopal',
        title: 'Dr. Krishan Gopal',
        description: 'With Dr Krishan Gopal, Joint General Secretary of RSS.',
        thumbnail: drKrishanGopal,
        images: [
            {
                src: drKrishanGopal,
                alt: 'Meeting with Dr. Krishan Gopal',
                description: 'Meeting with Dr. Krishan Gopal, Joint General Secretary of RSS'
            },
            {
                src: drKrishanGopal1,
                alt: 'With Dr. Krishan Gopal',
                description: 'Interaction with Dr. Krishan Gopal'
            },
            {
                src: drKrishanGopal2,
                alt: 'Event with Dr. Krishan Gopal',
                description: 'Event with Dr. Krishan Gopal'
            },
            {
                src: drKrishanGopal3,
                alt: 'Program with Dr. Krishan Gopal',
                description: 'Program with Dr. Krishan Gopal'
            }
        ]
    },
   
    {
        id: 'dinesh-chandra',
        title: 'Shri Dinesh Chandra',
        description: 'With Shri Dinesh Chandra Sharma, Antarrashtriya Sanrakshak, Vishva Hindu Parishad.',
        thumbnail: dineshChandraVHP1,
        images: [
           
            {
                src: dineshChandraVHP1,
                alt: 'With Shri Dinesh Chandra',
                description: 'Interaction with Shri Dinesh Chandra'
            },
            {
                src: dineshChandraVHP2,
                alt: 'Event with Shri Dinesh Chandra',
                description: 'Event with Shri Dinesh Chandra'
            },
            {
                src: dineshChandraVHP3,
                alt: 'With Shri Dinesh Chandra',
                description: 'Meeting with Shri Dinesh Chandra'
            }
        ]
    },
    {
        id: 'shri-sunil-ambekar',
        title: 'Shri Sunil Ambekar',
        description: 'With Shri Sunil Ambekar, Akhil Bharatiya Prachar Pramukh, Rashtriya Swayamsevak Sangh (RSS).',
        thumbnail: shriSunilAmbekar,
        images: [
            {
                src: shriSunilAmbekar,
                alt: 'Meeting with Shri Sunil Ambekar',
                description: 'Meeting with Shri Sunil Ambekar, Akhil Bharatiya Prachar Pramukh of RSS'
            },
            {
                src: shriSunilAmbekar1,
                alt: 'With Shri Sunil Ambekar',
                description: 'Interaction with Shri Sunil Ambekar'
            }
        ]
    },
    
    
    {
        id: 'suresh-soni-rss',
        title: 'Shri Suresh Soni',
        description: 'With Shri Suresh Soni, Akhil Bharatiya Karyakarini Sadasya and Former Joint General Secretary, Rashtriya Swayamsevak Sangh (RSS).',
        thumbnail: sureshSoniRSS,
        images: [
            {
                src: sureshSoniRSS,
                alt: 'Meeting with Shri Suresh Soni',
                description: 'Meeting with Shri Suresh Soni, RSS'
            },
            {
                src: sureshSoniRSS1,
                alt: 'With Shri Suresh Soni',
                description: 'Interaction with Shri Suresh Soni'
            },
            {
                src: sureshSoniRSS2,
                alt: 'Event with Shri Suresh Soni',
                description: 'Event with Shri Suresh Soni'
            },
            {
                src: sureshSoniRSS3,
                alt: 'With Shri Suresh Soni',
                description: 'Meeting with Shri Suresh Soni'
            },
             {
                src: sureshSoniRSS4,
                alt: 'Event with Shri Suresh Soni',
                description: 'Event with Shri Suresh Soni'
            },
            {
                src: sureshSoniRSS5,
                alt: 'With Shri Suresh Soni',
                description: 'Meeting with Shri Suresh Soni'
            }
        ]
    },
    {
        id: 'vishwa-bhushan-mishra',
        title: 'Shri Vishwa Bhushan Mishra',
        description: 'With Shri Vishwa Bhushan Mishra, Chief Executive Officer (CEO), Shri Kashi Vishwanath Temple, Varanasi.',
        thumbnail: vishwaBhushanMishra,
        images: [
            {
                src: vishwaBhushanMishra,
                alt: 'Meeting with Shri Vishwa Bhushan Mishra',
                description: 'Official meeting with Shri Vishwa Bhushan Mishra'
            },
            {
                src: vishwaBhushanMishra1,
                alt: 'With Vishwa Bhushan Mishra',
                description: 'Interaction with Shri Vishwa Bhushan Mishra'
            },
            {
                src: vishwaBhushanMishra2,
                alt: 'Event with Vishwa Bhushan Mishra',
                description: 'Event with Shri Vishwa Bhushan Mishra'
            },
            {
                src: vishwaBhushanMishra3,
                alt: 'Program with Vishwa Bhushan Mishra',
                description: 'Program with Shri Vishwa Bhushan Mishra'
            },
            {
                src: vishwaBhushanMishra4,
                alt: 'Meeting with Vishwa Bhushan Mishra',
                description: 'Meeting with Shri Vishwa Bhushan Mishra'
            },
            {
                src: vishwaBhushanMishra5,
                alt: 'With Vishwa Bhushan Mishra',
                description: 'Interaction with Shri Vishwa Bhushan Mishra'
            }
        ]
    },
    {
        id: 'sunil-bansal',
        title: 'Shri Sunil Bansal',
        description: 'With Shri Sunil Bansal, National General Secretary, BJP.',
        thumbnail: sunilBansal,
        images: [
            {
                src: sunilBansal,
                alt: 'Meeting with Shri Sunil Bansal',
                description: 'Meeting with Shri Sunil Bansal, National General Secretary of RSS'
            },
            {
                src: sunilBansal1,
                alt: 'With Shri Sunil Bansal',
                description: 'Interaction with Shri Sunil Bansal'
            },
            {
                src: sunilBansal2,
                alt: 'Event with Shri Sunil Bansal',
                description: 'Event with Shri Sunil Bansal'
            }
        ]
    },
    {
        id: 'harivansh-narayan-singh',
        title: 'Shri Harivansh Narayan Singh',
        description: 'With Shri Harivansh Narayan Singh, Deputy Chairman of Rajya Sabha.',
        thumbnail: harivanshNarayanSingh2,
        images: [
            {
                src: harivanshNarayanSingh,
                alt: 'With Harivansh Narayan Singh',
                description: 'Meeting with Shri Harivansh Narayan Singh'
            },
            {
                src: harivanshNarayanSingh1,
                alt: 'With Harivansh Narayan Singh',
                description: 'Interaction with Shri Harivansh Narayan Singh'
            },
            {
                src: harivanshNarayanSingh2,
                alt: 'Meeting with Harivansh Narayan Singh',
                description: 'Official meeting with Shri Harivansh Narayan Singh'
            },
            {
                src: harivanshNarayanSingh3,
                alt: 'With Harivansh Narayan Singh',
                description: 'Event with Shri Harivansh Narayan Singh'
            }
        ]
    },
      {
        id: 'former-vice-president',
        title: 'Shri Jagdeep Dhankhar',
        description: 'With Shri Jagdeep Dhankhar, Former Vice President of India.',
        thumbnail: jagdeepDhankarFormerVC,
        images: [
            {
                src: jagdeepDhankarFormerVC,
                alt: 'Meeting with Shri Jagdeep Dhankhar',
                description: 'Meeting with Shri Jagdeep Dhankhar, Former Vice President'
            },
            {
                src: jagdeepDhankar1FormerVC,
                alt: 'With Shri Jagdeep Dhankhar',
                description: 'Interaction with Shri Jagdeep Dhankhar'
            },
            {
                src: jagdeepDhankar2FormerVC,
                alt: 'Event with Shri Jagdeep Dhankhar',
                description: 'Event with Shri Jagdeep Dhankhar'
            }
        ]
    },
    
      {
        id: 'justice-sanjay-karol',
        title: 'Justice Sanjay Karol',
        description: 'With Justice Sanjay Karol, Judge, Supreme Court of India.',
        thumbnail: justiceSanjayKarol,
        images: [
            {
                src: justiceSanjayKarol,
                alt: 'Meeting with Justice Sanjay Karol',
                description: 'Meeting with Hon. Justice Sanjay Karol'
            }
        ]
    },
      {
        id: 'bhushan-gavai',
        title: 'Justice Bhushan Ramkrishna Gavai',
        description: 'With Justice B.R. Gavai, Former Chief Justice of India.',
        thumbnail: bhushanGavai,
        images: [
            {
                src: bhushanGavai,
                alt: 'Meeting with Justice Bhushan Ramkrishna Gavai',
                description: 'Meeting with Justice Bhushan Ramkrishna Gavai, Judge of the Supreme Court of India'
            },
            {
                src: bhushanGavai1,
                alt: 'With Justice Bhushan Ramkrishna Gavai',
                description: 'Interaction with Justice Bhushan Ramkrishna Gavai'
            },
            {
                src: bhushanGavai2,
                alt: 'Event with Justice Bhushan Ramkrishna Gavai',
                description: 'Event with Justice Bhushan Ramkrishna Gavai'
            },
            {
                src: bhushanGavai3,
                alt: 'With Justice Bhushan Ramkrishna Gavai',
                description: 'Meeting with Justice Bhushan Ramkrishna Gavai'
            }
        ]
    }, 
     {
        id: 'durga-shankar-mishra',
        title: 'Shri Durga Shankar Mishra',
        description: 'With Shri Durga Shankar Mishra, IAS (Retd.), Former Chief Secretary, Government of Uttar Pradesh.',
        thumbnail: durgaShankarMishra,
        images: [
            {
                src: durgaShankarMishra,
                alt: 'Meeting with Shri Durga Shankar Mishra',
                description: 'Official meeting with Shri Durga Shankar Mishra, Secretary, Ministry of Housing and Urban Affairs'
            },
            {
                src: durgaShankarMishra1,
                alt: 'With Shri Durga Shankar Mishra',
                description: 'Interaction with Shri Durga Shankar Mishra'
            },
            {
                src: durgaShankarMishra2,
                alt: 'Event with Shri Durga Shankar Mishra',
                description: 'Event with Shri Durga Shankar Mishra'
            },
            {
                src: durgaShankarMishra3,
                alt: 'With Shri Durga Shankar Mishra',
                description: 'Meeting with Shri Durga Shankar Mishra'
            }
        ]
    },
      {
        id: 'chief-minister2',
        title: 'Hon. Chief Minister of Madhya Pradesh',
        description: 'With Dr. Mohan Yadav, Chief Minister of Madhya Pradesh.',
        thumbnail: mohanYadavCMMP,
        images: [
             {
                src: mohanYadavCMMP,
                alt: 'Meeting with Hon. CM Mohan Yadav',
                description: 'Official meeting with Chief Minister Mohan Yadav'
            },
            {
                src: event3,
                alt: 'Event with CM Mohan Yadav',
                description: 'Event with Chief Minister Mohan Yadav'
            },
        ]
    },
     {
        id: 'governor-assam',
        title: 'Hon. Governor of Assam',
        description: 'With Shri Laxman Prasad Acharya, Governor of Assam.',
        thumbnail: laxmaAcharyaGovernorAssam,
        images: [
            {
                src: laxmaAcharyaGovernorAssam,
                alt: 'Meeting with Hon. Governor of Assam',
                description: 'Official meeting with the Governor of Assam'
            },
            {
                src: laxmaAcharyaGovernorAssam1,
                alt: 'With Governor of Assam',
                description: 'Interaction with the Governor of Assam'
            },
            {
                src: laxmaAcharyaGovernorAssam2,
                alt: 'Governor of Assam Event',
                description: 'Event with the Governor of Assam'
            },
            {
                src: laxmaAcharyaGovernorAssam3,
                alt: 'With Governor of Assam',
                description: 'Meeting with the Governor of Assam'
            }
        ]
    },
    {
        id: 'darshana-singh',
        title: 'Smt. Darshana Singh',
        description: 'With Smt. Darshana Singh, Member of Parliament Rajya Sabha, BJP.',
        thumbnail: darshanaSingh,
        images: [
            {
                src: darshanaSingh,
                alt: 'Meeting with Smt. Darshana Singh',
                description: 'Official meeting with Smt. Darshana Singh, Former Governor of Chhattisgarh'
            },
            {
                src: darshanaSingh1,
                alt: 'With Smt. Darshana Singh',
                description: 'Interaction with Smt. Darshana Singh'
            },
            {
                src: darshanaSingh2,
                alt: 'Event with Smt. Darshana Singh',
                description: 'Event with Smt. Darshana Singh'
            },
            {
                src: darshanaSingh3,
                alt: 'With Smt. Darshana Singh',
                description: 'Meeting with Smt. Darshana Singh'
            }
        ]
    },
     {
        id: 'mahendra-nath-pandey',
        title: 'Shri Mahendra Nath Pandey',
        description: 'With Dr. Mahendra Nath Pandey, Former Union Minister & Former BJP Uttar Pradesh President.',
        thumbnail: mahendraNathPandey,
        images: [
            {
                src: mahendraNathPandey,
                alt: 'Meeting with Shri Mahendra Nath Pandey',
                description: 'Official meeting with Shri Mahendra Nath Pandey, Former Union Minister'
            },
            {
                src: mahendraNathPandey1,
                alt: 'With Shri Mahendra Nath Pandey',
                description: 'Interaction with Shri Mahendra Nath Pandey'
            },
            {
                src: mahendraNathPandey2,
                alt: 'Event with Shri Mahendra Nath Pandey',
                description: 'Event with Shri Mahendra Nath Pandey'
            },
            {
                src: event1,
                alt: 'Special Event',
                description: 'Special program and event'
            },
            {
                src: event2,
                alt: 'Program Event',
                description: 'Special program event'
            },
        ]
    },
    {
        id: 'governor',
        title: 'Hon. Governor of Uttar Pradesh',
        description: 'With Smt Anandiben Patel, Governor of Uttar Pradesh.',
        thumbnail: governer,
        images: [
            {
                src: governer,
                alt: 'Meeting with Hon. Governor',
                description: 'Official meeting with the Governor of Uttar Pradesh'
            },
            {
                src: governor2,
                alt: 'With Governor',
                description: 'Interaction with the Governor of Uttar Pradesh'
            },
            {
                src: governor3,
                alt: 'Governor Event',
                description: 'Event with the Governor of Uttar Pradesh'
            },
            {
                src: governor4,
                alt: 'Governor Program',
                description: 'Program with the Governor of Uttar Pradesh'
            },
           
            {
                src: governor7,
                alt: 'Governor Event',
                description: 'Event with the Governor of Uttar Pradesh'
            },
            {
                src: governor8,
                alt: 'With Governor',
                description: 'Meeting with the Governor of Uttar Pradesh'
            },
            {
                src: governor9,
                alt: 'Governor Program',
                description: 'Program with the Governor of Uttar Pradesh'
            },
            {
                src: governor10,
                alt: 'With Governor',
                description: 'Interaction with the Governor of Uttar Pradesh'
            }
        ]
    },
    
   
    {
        id: 'chief-minister1',
        title: 'Hon. Chief Minister of Uttar Pradesh',
        description: 'With Shri Yogi Adityanath, Chief Minister of UP.',
        thumbnail: yogiCMUP5,
        images: [
            {
                src: yogiCMUP2,
                alt: 'With CM Yogi Adityanath',
                description: 'Interaction with Chief Minister of Uttar Pradesh'
            },
            {
                src: yogiCMUP3,
                alt: 'CM Event',
                description: 'Event with Chief Minister Yogi Adityanath'
            },
            {
                src: yogiCMUP5,
                alt: 'CM Program',
                description: 'Program with Chief Minister Yogi Adityanath'
            },
            {
                src: yogiCMUP8,
                alt: 'With CM',
                description: 'Meeting with Chief Minister Yogi Adityanath'
            },
            {
                src: yogiCMUP9,
                alt: 'CM Program',
                description: 'Program with Chief Minister of Uttar Pradesh'
            },
            {
                src: yogiCMUP10,
                alt: 'With CM Yogi',
                description: 'Interaction with Chief Minister Yogi Adityanath'
            },
            {
                src: yogiCMUP11,
                alt: 'CM Event',
                description: 'Event with Chief Minister of Uttar Pradesh'
            },
            {
                src: yogiCMUP12,
                alt: 'With CM',
                description: 'Meeting with Chief Minister Yogi Adityanath'
            }
        ]
    },
   
    {
        id: 'deputy-cm',
        title: 'Hon. Deputy Chief Minister',
        description: 'With Shri Keshav Prasad Maurya, Deputy Chief Minister of UP.',
        thumbnail: deputyCM,
        images: [
            {
                src: deputyCM,
                alt: 'Meeting with Deputy CM',
                description: 'Official meeting with Deputy Chief Minister of Uttar Pradesh'
            },
            {
                src: deputyCM2,
                alt: 'With Deputy CM',
                description: 'Interaction with Deputy Chief Minister'
            }
        ]
    },
    {
        id: 'tourism-minister',
        title: 'Hon. Tourism Minister',
        description: 'With Shri Jaiveer Singh, Tourism Minister of Uttar Pradesh.',
        thumbnail: tourisomMinister,
        images: [
            {
                src: tourisomMinister,
                alt: 'Meeting with Tourism Minister',
                description: 'Official meeting with Tourism Minister'
            },
            {
                src: tourisomMinister2,
                alt: 'With Tourism Minister',
                description: 'Interaction with Tourism Minister'
            },
            {
                src: tourisomMinister3,
                alt: 'Tourism Minister Event',
                description: 'Event with Tourism Minister'
            },
            {
                src: tourisomMinister4,
                alt: 'With Tourism Minister',
                description: 'Meeting with Tourism Minister'
            },
            {
                src: tourisomMinister5,
                alt: 'Tourism Minister Program',
                description: 'Program with Tourism Minister'
            },
            {
                src: tourisomMinister7,
                alt: 'Tourism Minister Event',
                description: 'Event with Tourism Minister'
            }
        ]
    },
    {
        id: 'transport-minister',
        title: 'Hon. Transport Minister',
        description: 'With Shri Dayashankar Singh, Transport Minister of Uttar Pradesh.',
        thumbnail: transportMinister,
        images: [
            {
                src: transportMinister,
                alt: 'Meeting with Transport Minister',
                description: 'Official meeting with Transport Minister'
            },
            {
                src: transportMinister2,
                alt: 'With Transport Minister',
                description: 'Interaction with Transport Minister'
            },
            {
                src: transportMinister3,
                alt: 'Transport Minister Event',
                description: 'Event with Transport Minister'
            }
        ]
    },
    {
        id: 'higher-education-minister',
        title: 'Hon. Higher Education Minister',
        description: 'With Shri Yogendra Upadhyaya, Higher Education Minister of Uttar Pradesh.',
        thumbnail: higherEducationMinister,
        images: [
            {
                src: higherEducationMinister,
                alt: 'Meeting with Higher Education Minister',
                description: 'Official meeting with Higher Education Minister'
            },
            {
                src: higherEducationMinister1,
                alt: 'With Higher Education Minister',
                description: 'Interaction with Higher Education Minister'
            }
        ]
    },
    
    {
        id: 'cabinet-minister',
        title: 'Shri Suresh Kumar Khanna',
        description: 'With Shri Suresh Kumar Khanna, Finance and Parliamentary Affairs Minister, Uttar Pradesh.',
        thumbnail: shriSureshKumarKhanna,
        images: [
            {
                src: shriSureshKumarKhanna,
                alt: 'Meeting with Cabinet Minister',
                description: 'With Shri Suresh Kumar Khanna, Finance and Parliamentary Affairs Minister, Uttar Pradesh'
            },
            {
                src: shriSureshKumarKhanna1,
                alt: 'With Shri Suresh Kumar Khanna',
                description: 'Interaction with Shri Suresh Kumar Khanna'
            }
        ]
    },
    {
        id: 'former-education-minister',
        title: 'Former Education Minister of India',
        description: 'With Shri Ramesh Pokhriyal Nishank, Former Union Education Minister of India and Former Chief Minister of Uttarakhand.',
        thumbnail: formerEducationMinisterIndia,
        images: [
            {
                src: formerEducationMinisterIndia,
                alt: 'Meeting with Former Education Minister',
                description: 'Meeting with Former Education Minister of India'
            }
        ]
    },
    
    {
        id: 'bhupendrasinh-chudasama',
        title: 'Shri Bhupendrasinh Chudasama',
        description: 'With Shri Bhupendrasinh Chudasama, former gujrat cabinet minister.',
        thumbnail: bhupendrasinhChudasama,
        images: [
            {
                src: bhupendrasinhChudasama,
                alt: 'Meeting with Shri Bhupendrasinh Chudasama',
                description: 'Meeting with Shri Bhupendrasinh Chudasama, Former Education Minister of Gujarat'
            },
            {
                src: bhupendrasinhChudasama1,
                alt: 'With Shri Bhupendrasinh Chudasama',
                description: 'Interaction with Shri Bhupendrasinh Chudasama'
            },
            {
                src: bhupendrasinhChudasama2,
                alt: 'Event with Shri Bhupendrasinh Chudasama',
                description: 'Event with Shri Bhupendrasinh Chudasama'
            },
            {
                src: bhupendrasinhChudasama3,
                alt: 'With Shri Bhupendrasinh Chudasama',
                description: 'Meeting with Shri Bhupendrasinh Chudasama'
            },
            {
                src: bhupendrasinhChudasama4,
                alt: 'Event with Shri Bhupendrasinh Chudasama',
                description: 'Event with Shri Bhupendrasinh Chudasama'
            }
        ]
    },
    {
        id: 'mayor-varanasi',
        title: 'Shri Ashok Kumar Tiwari',
        description: 'With Shri Ashok Kumar Tiwari, Mayor of Varanasi.',
        thumbnail: shriAshokKumarTiwariMayor,
        images: [
            {
                src: shriAshokKumarTiwariMayor,
                alt: 'Meeting with Mayor of Varanasi',
                description: 'Meeting with Shri Ashok Kumar Tiwari, Mayor of Varanasi'
            },
            {
                src: shriAshokKumarTiwariMayor1,
                alt: 'With Mayor of Varanasi',
                description: 'Interaction with Shri Ashok Kumar Tiwari'
            },
            {
                src: shriAshokKumarTiwariMayor2,
                alt: 'Event with Mayor of Varanasi',
                description: 'Event with Shri Ashok Kumar Tiwari'
            },
            {
                src: shriAshokKumarTiwariMayor3,
                alt: 'With Mayor of Varanasi',
                description: 'Meeting with Shri Ashok Kumar Tiwari'
            }
        ]
    },
    {
        id: 'missouri-state-treasurer',
        title: 'Missouri State Treasurer',
        description: 'With Mr Vivek Malek, State Treasurer of Missouri, USA, and Mr Vishal Malik, Founder & CEO, Gemini Solutions.',
        thumbnail: missouriStateTreasurer,
        images: [
            {
                src: missouriStateTreasurer,
                alt: 'Meeting with Missouri State Treasurer',
                description: 'Meeting with Missouri State Treasurer and Founder of Gemini Solution'
            },
            {
                src: missouriStateTreasurer1,
                alt: 'With Missouri State Treasurer',
                description: 'Interaction with Missouri State Treasurer and Gemini Solutions Founder'
            }
        ]
    },
  
    {
        id: 'neelkanth-tiwari',
        title: 'Shri Neelkanth Tiwari',
        description: 'With Shri Neelkanth Tiwari, MLA, Varanasi South and Former Minister, Government of Uttar Pradesh.',
        thumbnail: shriNeelkanthTiwari,
        images: [
            {
                src: shriNeelkanthTiwari,
                alt: 'Meeting with Neelkanth Tiwari',
                description: 'Meeting with Shri Neelkanth Tiwari, Member of UP Legislative Assembly'
            }
        ]
    },
    {
        id: 'prem-kumar-speaker-bihar',
        title: 'Shri Prem Kumar',
        description: 'With Dr. Prem Kumar, Speaker of the Bihar Legislative Assembly.',
        thumbnail: premKumarSpeakerBihar,
        images: [
            {
                src: premKumarSpeakerBihar,
                alt: 'Meeting with Hon. Speaker of Bihar',
                description: 'Official meeting with Shri Prem Kumar, Hon. Speaker of Bihar Legislative Assembly'
            },
            {
                src: premKumarSpeakerBihar1,
                alt: 'With Speaker Prem Kumar',
                description: 'Interaction with Hon. Speaker of Bihar Legislative Assembly'
            },
            {
                src: premKumarSpeakerBihar2,
                alt: 'Speaker of Bihar Program',
                description: 'Program with Shri Prem Kumar, Speaker of Bihar'
            },
            {
                src: premKumarSpeakerBihar3,
                alt: 'With Bihar Speaker',
                description: 'Meeting with Hon. Speaker of Bihar Legislative Assembly'
            },
            {
                src: premKumarSpeakerBihar4,
                alt: 'Speaker Prem Kumar Event',
                description: 'Event with Shri Prem Kumar, Speaker of Bihar Legislative Assembly'
            }
        ]
    },
    {
        id: 'ramesh-chander-kaushik',
        title: 'Shri Ramesh Chander Kaushik',
        description: 'With Ramesh Chander Kaushik, Former Member of Parliament (Lok Sabha) and Nirmal Chaudhary, Former Member of Legislative Assembly Haryana.',
        thumbnail: rameshChanderKaushik,
        images: [
            {
                src: rameshChanderKaushik,
                alt: 'Meeting with Shri Ramesh Chander Kaushik',
                description: 'Official meeting with Shri Ramesh Chander Kaushik, Former Governor of Mizoram'
            },
            {
                src: rameshChanderKaushik1,
                alt: 'With Shri Ramesh Chander Kaushik',
                description: 'Interaction with Shri Ramesh Chander Kaushik'
            }
        ]
    },
       {
        id: 'gyan-prakash-singh',
        title: 'Mr. Gyan Prakash Singh',
        description: 'With Mr Gyan Prakash Singh, Chairman and MD of Modern Group of Companies.',
        thumbnail: gyanPrakashSharmaJonpur,
        images: [
            {
                src: gyanPrakashSharmaJonpur,
                alt: 'With Mr. Gyan Prakash Singh',
                description: 'Meeting with Mr. Gyan Prakash Singh, Jaunpur'
            },
            {
                src: gyanPrakashSharmaJonpur1,
                alt: 'Mr. Gyan Prakash Singh Event',
                description: 'Event with Mr. Gyan Prakash Singh'
            },
            {
                src: gyanPrakashSharmaJonpur2,
                alt: 'With Mr. Gyan Prakash Singh',
                description: 'Interaction with Mr. Gyan Prakash Singh'
            }
        ]
    },
  
     {
        id: 'rambhadracharya',
        title: 'Jagadguru Rambhadracharya',
        description: 'With Spiritual leader Jagadguru Rambhadracharya.',
        thumbnail: rambhadracharya,
        images: [
            {
                src: rambhadracharya,
                alt: 'With Jagadguru Rambhadracharya',
                description: 'Meeting with spiritual leader Jagadguru Rambhadracharya'
            },
           
        ]
    },
    {
        id: 'bhadresdas-swami',
        title: 'Bhadresdas Swami',
        description: 'With Bhadreshdas Swami, Head of Research, BAPS Swaminarayan Sanstha.',
        thumbnail: bhadresdasSwami,
        images: [
            {
                src: bhadresdasSwami,
                alt: 'Meeting with Bhadresdas Swami',
                description: 'Meeting with Bhadresdas Swami, BAPS Swaminarayan Sanstha'
            },
            {
                src: bhadresdasSwami1,
                alt: 'With Bhadresdas Swami',
                description: 'Interaction with Bhadresdas Swami'
            },
            {
                src: bhadresdasSwami2,
                alt: 'Event with Bhadresdas Swami',
                description: 'Event with Bhadresdas Swami'
            }
        ]
    },
    {
        id: 'bhartiya-basant-kumar',
        title: 'Shri Bhartiya Basant Kumar',
        description: 'With Shri Bhartiya Basant Kumar, Senior News Editor, Dainik Jagran.',
        thumbnail: bhartiyaBasantKumar,
        images: [
            {
                src: bhartiyaBasantKumar,
                alt: 'Meeting with Shri Bhartiya Basant Kumar',
                description: 'Official meeting with Shri Bhartiya Basant Kumar'
            },
            {
                src: bhartiyaBasantKumar1,
                alt: 'With Bhartiya Basant Kumar',
                description: 'Interaction with Shri Bhartiya Basant Kumar'
            },
            {
                src: bhartiyaBasantKumar2,
                alt: 'Event with Bhartiya Basant Kumar',
                description: 'Event with Shri Bhartiya Basant Kumar'
            },
            {
                src: bhartiyaBasantKumar3,
                alt: 'Program with Bhartiya Basant Kumar',
                description: 'Program with Shri Bhartiya Basant Kumar'
            },
            {
                src: bhartiyaBasantKumar4,
                alt: 'Meeting with Bhartiya Basant Kumar',
                description: 'Meeting with Shri Bhartiya Basant Kumar'
            }
        ]
    },
     {
        id: 'ncc',
        title: 'National Cadet Corps (NCC)',
        description: 'With National Cadet Corps (NCC) Cadets.',
        thumbnail: ncc1,
        images: [
            {
                src: ncc1,
                alt: 'NCC Event',
                description: 'National Cadet Corps event and activities'
            },
            {
                src: ncc2,
                alt: 'NCC Program',
                description: 'NCC program and training activities'
            },
            {
                src: ncc3,
                alt: 'NCC Activities',
                description: 'NCC cadets and training programs'
            },
            {
                src: ncc4,
                alt: 'NCC Training',
                description: 'NCC training and development activities'
            },
            {
                src: ncc5,
                alt: 'NCC Event',
                description: 'NCC event and ceremonial activities'
            },
            {
                src: ncc6,
                alt: 'NCC Program',
                description: 'NCC program and cadet activities'
            },
            {
                src: ncc7,
                alt: 'NCC Activities',
                description: 'NCC activities and training programs'
            }
        ]
    },
    {
        id: 'events-programs',
        title: 'Events & Programs',
        description: 'Cultural, academic, and special events.',
        thumbnail: worldTourisomDay,
        images: [
            {
                src: worldTourisomDay,
                alt: 'World Tourism Day',
                description: 'World Tourism Day celebration'
            },
            {
                src: kashiVishvnath,
                alt: 'Kashi Vishwanath Temple',
                description: 'Visit to Kashi Vishwanath Temple'
            },
            {
                src: convocation43rdGoverner,
                alt: '43rd Convocation with Governor',
                description: '43rd Convocation ceremony with Governor'
            },
            {
                src: convocation43rdGovernor2,
                alt: '43rd Convocation',
                description: '43rd Convocation ceremony'
            },
            {
                src: sanskritScholarshipCm,
                alt: 'Sanskrit Scholarship Program',
                description: 'Sanskrit Scholarship Program with Chief Minister'
            },
            {
                src: council,
                alt: 'Council Meeting',
                description: 'Academic council meeting'
            },
            {
                src: library,
                alt: 'Library Event',
                description: 'Library inauguration or event'
            },
            {
                src: ujjan,
                alt: 'Ujjain Event',
                description: 'Academic event in Ujjain'
            },
            {
                src: mpEducationMeeting,
                alt: 'MP Education Meeting',
                description: 'Madhya Pradesh Education Meeting'
            },
            {
                src: event4,
                alt: 'Special Event',
                description: 'Special program and event'
            },
            {
                src: event5,
                alt: 'Event',
                description: 'Special event'
            },
            {
                src: event6,
                alt: 'Special Event',
                description: 'Special program and event'
            },
            {
                src: event7,
                alt: 'Program Event',
                description: 'Special program event'
            },
            {
                src: event8,
                alt: 'Special Program',
                description: 'Special program'
            },
            {
                src: event9,
                alt: 'Event',
                description: 'Special event'
            },
            {
                src: event10,
                alt: 'Special Event',
                description: 'Special program and event'
            },
            {
                src: event11,
                alt: 'Program Event',
                description: 'Special program event'
            },
            {
                src: event12,
                alt: 'University Event',
                description: 'University program and event'
            },
            {
                src: event13,
                alt: 'Academic Event',
                description: 'Academic program and event'
            },
            {
                src: spiritual,
                alt: 'Spiritual Event',
                description: 'Spiritual gathering and event'
            },
            {
                src: event14,
                alt: 'Special Event',
                description: 'Special program and event'
            },
            {
                src: event15,
                alt: 'University Program',
                description: 'University program and activities'
            },
            {
                src: event16,
                alt: 'Campus Event',
                description: 'Campus event and activities'
            },
            {
                src: event17,
                alt: 'Academic Program',
                description: 'Academic program and event'
            },
            {
                src: event18,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: event19,
                alt: 'Campus Activity',
                description: 'Campus activity and event'
            },
            {
                src: event20,
                alt: 'Academic Event',
                description: 'Academic event and program'
            },
            {
                src: event21,
                alt: 'University Program',
                description: 'University program and activities'
            },
            {
                src: event22,
                alt: 'Campus Event',
                description: 'Campus event and activities'
            },
            {
                src: event23,
                alt: 'Academic Activity',
                description: 'Academic activity and event'
            },
            {
                src: event24,
                alt: 'University Event',
                description: 'University event and program'
            },
            {
                src: event25,
                alt: 'Campus Program',
                description: 'Campus program and activities'
            },
            {
                src: event26,
                alt: 'Academic Event',
                description: 'Academic event and activities'
            },
            {
                src: event27,
                alt: 'University Activity',
                description: 'University activity and event'
            },
            {
                src: event28,
                alt: 'Campus Event',
                description: 'Campus event and program'
            },
            {
                src: event29,
                alt: 'Academic Program',
                description: 'Academic program and event'
            },
            {
                src: event30,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: event31,
                alt: 'Campus Activity',
                description: 'Campus activity and event'
            },
            {
                src: event32,
                alt: 'Academic Event',
                description: 'Academic event and program'
            },
            {
                src: event33,
                alt: 'University Program',
                description: 'University program and activities'
            },
            {
                src: event34,
                alt: 'Campus Event',
                description: 'Campus event and activities'
            },
            {
                src: event35,
                alt: 'Academic Activity',
                description: 'Academic activity and event'
            },
            {
                src: event36,
                alt: 'University Event',
                description: 'University event and program'
            },
            {
                src: event37,
                alt: 'Campus Program',
                description: 'Campus program and activities'
            },
            {
                src: event38,
                alt: 'Academic Event',
                description: 'Academic event and activities'
            },
            {
                src: event39,
                alt: 'University Activity',
                description: 'University activity and event'
            },
            {
                src: event40,
                alt: 'Campus Event',
                description: 'Campus event and program'
            },
            {
                src: event41,
                alt: 'Academic Program',
                description: 'Academic program and event'
            },
            {
                src: event42,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: event43,
                alt: 'Campus Activity',
                description: 'Campus activity and event'
            },
            {
                src: event44,
                alt: 'Academic Event',
                description: 'Academic event and program'
            },
            {
                src: event45,
                alt: 'University Program',
                description: 'University program and activities'
            },
            {
                src: event46,
                alt: 'Campus Event',
                description: 'Campus event and activities'
            },
            {
                src: event47,
                alt: 'Academic Activity',
                description: 'Academic activity and event'
            },
            {
                src: event48,
                alt: 'University Event',
                description: 'University event and program'
            },
            {
                src: event49,
                alt: 'Campus Program',
                description: 'Campus program and activities'
            },
            {
                src: event50,
                alt: 'Academic Event',
                description: 'Academic event and activities'
            },
            {
                src: event51,
                alt: 'University Activity',
                description: 'University activity and event'
            },
            {
                src: event52,
                alt: 'Campus Event',
                description: 'Campus event and program'
            },
            {
                src: event53,
                alt: 'Academic Program',
                description: 'Academic program and event'
            },
            {
                src: event54,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: event55,
                alt: 'Campus Activity',
                description: 'Campus activity and event'
            },
            {
                src: event56,
                alt: 'Academic Event',
                description: 'Academic event and program'
            },
            {
                src: event57,
                alt: 'University Program',
                description: 'University program and activities'
            },
            {
                src: event58,
                alt: 'Campus Event',
                description: 'Campus event and activities'
            },
            {
                src: event59,
                alt: 'Academic Activity',
                description: 'Academic activity and event'
            },
            {
                src: event60,
                alt: 'University Event',
                description: 'University event and program'
            },
            {
                src: event61,
                alt: 'Campus Program',
                description: 'Campus program and activities'
            },
            {
                src: event62,
                alt: 'Academic Event',
                description: 'Academic event and activities'
            },
            {
                src: event63,
                alt: 'University Activity',
                description: 'University activity and event'
            },
            {
                src: event64,
                alt: 'Campus Event',
                description: 'Campus event and program'
            },
            {
                src: event65,
                alt: 'Academic Program',
                description: 'Academic program and event'
            },
            {
                src: event66,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: event67,
                alt: 'Campus Activity',
                description: 'Campus activity and event'
            },
            {
                src: event68,
                alt: 'Academic Event',
                description: 'Academic event and program'
            },
            {
                src: event69,
                alt: 'University Program',
                description: 'University program and activities'
            },
            {
                src: event70,
                alt: 'Campus Event',
                description: 'Campus event and activities'
            },
            {
                src: event71,
                alt: 'Academic Activity',
                description: 'Academic activity and event'
            },
            {
                src: event72,
                alt: 'University Event',
                description: 'University event and program'
            },
            {
                src: event73,
                alt: 'Campus Program',
                description: 'Campus program and activities'
            },
            {
                src: event74,
                alt: 'Academic Event',
                description: 'Academic event and activities'
            },
            {
                src: event75,
                alt: 'University Activity',
                description: 'University activity and event'
            },
            {
                src: event76,
                alt: 'Campus Event',
                description: 'Campus event and program'
            },
            {
                src: event77,
                alt: 'Academic Program',
                description: 'Academic program and event'
            },
            {
                src: event78,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: event79,
                alt: 'Campus Activity',
                description: 'Campus activity and event'
            },
            {
                src: event80,
                alt: 'Academic Event',
                description: 'Academic event and program'
            },
            {
                src: universityEvent01,
                alt: 'University Event',
                description: 'University event and activities'
            },
            {
                src: danikjagran,
                alt: 'Dainik Jagran Event',
                description: 'Media interaction with Dainik Jagran'
            },
            {
                src: danikjagran3,
                alt: 'Media Event',
                description: 'Media event and press interaction'
            },
            {
                src: danikjagran6,
                alt: 'Press Event',
                description: 'Press event and media interaction'
            },
            {
                src: danikjagran7,
                alt: 'Media Interaction',
                description: 'Media interaction and press coverage'
            }
        ]
    },
   
];
